import { render, staticRenderFns } from "./CustomerFormMobile.vue?vue&type=template&id=1ff330e8&scoped=true&"
import script from "./CustomerFormMobile.vue?vue&type=script&lang=js&"
export * from "./CustomerFormMobile.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFormMobile.vue?vue&type=style&index=0&id=1ff330e8&prod&scoped=true&lang=css&"
import style1 from "./CustomerFormMobile.vue?vue&type=style&index=1&id=1ff330e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff330e8",
  null
  
)

export default component.exports